export const fourwavesCanadaStripePublishableKey =
  'pk_live_5103SBp2YrdRNb5IRoaYkpes6JqOGJFBJJzNA9j4oDKWiusoVsBx2R4HWAjzFU59xG6JvGEGeHOMOBHzL9FLYAMO300mTZsqhMC';

export const fourwavesEuropeStripePublishableKey =
  'pk_live_51PK2DULA7zVOKnlS305S0adgRvBbjtzFH5FOV3jD0lz6trIC6fKgSci6QTeKCLYrURJaiVdUH6hOfDR0mzkE2oxR00fLuX36SB';

export const fourwavesCanadaPayPalMerchantId = 'AMB5E96Z7UMDU';
